export default __webpack_public_path__ + "static/media/what-we-provide-market-icon.91929c33.svg";